var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1999 3.99976L6.07992 5.11975L8.15989 7.19972H0V8.7997H8.15989L6.07992 10.8797L7.1999 11.9997L11.1998 7.99971L7.1999 3.99976ZM14.3998 13.5996H7.99989V15.1996H14.3998C15.2798 15.1996 15.9998 14.4796 15.9998 13.5996V2.39978C15.9998 1.51979 15.2798 0.799805 14.3998 0.799805H7.99989V2.39978H14.3998V13.5996Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/Checkin.94a471742d12829c2d754feff1d7f408.svg";
export { ForwardRef as ReactComponent };